import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-drinks2.png";
import IGKDS from "../../../assets/img/Featured/tablet-kitchen-system.png";

const CoffeeShopPage = () => {
    const DigitalMenu = "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/touchpoint-all-assets/featured-solution-nav/digital-menu.png";

    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page coffeeShopPage">
            <Header />
            <div className="page-header">Healthcare Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Coffee Shop</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Agilysys InfoGenesis POS provides staff and visitors 
                    with convenient self-service ordering and quick 
                    payment options.{'\n\n'}

                    The result is fast, accurate and on-time food delivery to 
                    keep service moving.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Cafe", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Cafe", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Cafe", "IG KDS");
                    addFlow("IG KDS");
                    navigate("/solutions/ig-kds")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG KDS
                    </div>
                    <img src={IGKDS} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default CoffeeShopPage;